import { FavoriteRounded } from '@mui/icons-material';
import { Box, Stack } from '@mui/material';
import { FC } from 'react';
import { DetailsBox } from './DetailsBox';
import AddRoadIcon from '@mui/icons-material/AddRoad';
import SpeedIcon from '@mui/icons-material/Speed';
import { formatTime } from '../../../../../Utils/DateUtils';

type RightDetailsProps = {
  pace: number;
  distance: number;
  heartRate: number;
};

export const RightDetails: FC<RightDetailsProps> = ({
  pace,
  distance,
  heartRate,
}) => {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: '#202123',
        height: '100%',
        padding: 2,
      })}
    >
      <Stack
        direction="column"
        spacing={2}
        className="w-full"
        justifyContent="center"
        alignContent="center"
        sx={(theme) => ({ height: '100%' })}
      >
        <DetailsBox
          number={distance.toFixed(3)}
          title={'distance'}
          subtitle={'km'}
          color="#48dbc5ff"
          icon={
            <AddRoadIcon
              fontSize="inherit"
              sx={{
                position: 'absolute',
                top: '23px',
                fontSize: 42,
                color: '#48dbc5ff',
              }}
            />
          }
          left={false}
        />
        <DetailsBox
          number={
            pace > 0 ? formatTime((Math.round(pace * 100) / 100) * 60) : '00:00'
          }
          title={'pace'}
          subtitle={'min/km'}
          color="#4fcbfcff"
          icon={
            <SpeedIcon
              fontSize="inherit"
              sx={{
                position: 'absolute',
                top: '23px',
                fontSize: 42,
                color: '#4fcbfcff',
              }}
            />
          }
          left={false}
        />
        <DetailsBox
          number={heartRate}
          title={'heart rate'}
          subtitle={'BPM'}
          color="#ef3506ff"
          icon={
            <FavoriteRounded
              fontSize="inherit"
              sx={{
                position: 'absolute',
                top: '23px',
                fontSize: 42,
                color: '#ef3506ff',
              }}
            />
          }
          left={false}
        />
      </Stack>
    </Box>
  );
};
